import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import { clothDiaperNewKey } from '../../src/Constants/GeneralItemsKeys';
import {
  getFilteredCategoryContent,
  replaceUnderscore,
} from '../../src/Utils/helper';
import { addTocartBogoHandler } from '../../src/Utils/productAction';
import DiaperNewVersionMain from '../../src/components/StoreCategoryPage/DiaperNewVersionMain';
import {
  getProductIds,
  reviewDataHandler,
} from '../../src/components/StoreHomePage/BogoClothDiaper/common';
import {
  categoryNavBarDataFetcher,
  tabByKeyFetcher,
} from '../../src/datafetchers/CategoryPage';
import {
  productFetcher,
  reviewFetcher,
} from '../../src/datafetchers/productPage';
import { showNewReviewSection } from '../../src/components/StoreCategoryPage/common';
import { getWebUserType } from '../../src/Utils/getWebUserType';
import Head from 'next/head';

export async function getStaticProps(context) {
  const category = clothDiaperNewKey;
  const generalItemsData = await tabByKeyFetcher({
    key: replaceUnderscore(category),
    type: context?.query?.type,
  });
  let data = null;
  let freebieProductItems = null;
  generalItemsData?.data?.items?.map((element) => {
    if (
      element?.items?.[0]?.itemType == 'PRODUCT' &&
      element.itemType == 'MULTIPLE_ITEMS'
    ) {
      data = element?.items;
    } else if (
      element?.items?.[0]?.itemType == 'PRODUCT' &&
      element.itemType == 'OFFER_LOCKED_FREEBIE_LIST'
    ) {
      freebieProductItems = element?.items;
    }
  });

  const productIds = getProductIds(data);
  const freebieProductIds = getProductIds(freebieProductItems);
  const categoryNavBarApiData = await categoryNavBarDataFetcher();
  const params = {
    productId: '970',
    ids: productIds,
    add: false,
    less: false,
    addToCart: false,
    isFirstTime: false,
    selectProduct: true,
    freebieProductIds,
  };
  const diaperOfferData = await addTocartBogoHandler(params, false, '4');
  const reviewDataData = await reviewFetcher('504', false, 0, 1);
  generalItemsData.data.items = generalItemsData?.data?.items.filter(
    (element, index) =>
      element._id === '1490' ||
      element._id === '2930' ||
      element._id === '5997' ||
      element._id === '5994' ||
      element._id === '6150' ||
      element._id === '6000',
  );
  const productData = await productFetcher(`api/getProduct/504`);

  return {
    props: {
      generalItemsData: generalItemsData?.data,
      diaperOfferData: diaperOfferData,
      categoryData: getFilteredCategoryContent(categoryNavBarApiData?.data),
      reviewdata: reviewDataHandler(reviewDataData),
      productIds: productIds,
      category: category,
      experimentUserType: 'A',
      freebieProductIds,
      productData,
    },
    revalidate: 60,
  };
}

function ClothDiaperComponent(props) {
  const {
    generalItemsData,
    categoryData,
    category,
    reviewdata,
    diaperOfferData,
    productIds,
    experimentUserType,
    freebieProductIds,
    productData,
  } = props;
  useEffect(() => {
    Cookies.set('b2G1Page', false);
    localStorage.setItem('option', 4);
    Cookies.set('b2g1_locked_products', freebieProductIds);
  }, []);

  const userType = getWebUserType();
  const showNewCDDDPage = showNewReviewSection(userType);
  return (
    <>
      <Head>
        <meta property="og:title" content={productData?.data?.name} />
        <meta property="og:type" content="category" />
        <meta
          property="og:url"
          content={`https://mylofamily.com/${productData?.data?.web_url}`}
        />
        <meta property="og:image" content={productData?.data?.images?.[0]} />
        <meta
          property="og:description"
          content={productData?.data?.description}
        />
        <meta property="og:site_name" content="Mylo" />
        <meta property="og:locale" content="en_US" />
      </Head>
      <DiaperNewVersionMain
        generalItemsData={generalItemsData}
        categoryData={categoryData}
        reviewdata={reviewdata}
        diaperOfferData={diaperOfferData}
        productIds={productIds}
        offerKey={category}
        firstLineHeading={"India's"}
        secondLineHeading={'Cloth Diapers'}
        show3d={true}
        isIndex={true}
        experimentUserType={experimentUserType}
        isForNewCdPage={true}
        showNewCDDDPage={showNewCDDDPage}
        productData={productData?.data}
      />
    </>
  );
}

export default ClothDiaperComponent;
